// src/components/Admin/LeadPricingSetup/ConditionDefinitionList.jsx
import React from 'react';
import { Button } from '../../../ui/button'; // Updated
import { Card, CardContent,  CardFooter, CardHeader, CardTitle } from '../../../ui/card'; // Updated [cite: 15]
import { Badge } from '../../../ui/badge'; // Updated [cite: 18]
import { cn } from '../../../../lib/utils';

export default function ConditionDefinitionList({ items, onEdit, onDelete }) {
    if (!items || items.length === 0) {
        return <p className="text-muted-foreground">No condition definitions found.</p>; // [cite: 1]
    }

    return (
        <div className="space-y-4"> {/* Increased spacing */}
            {items.map(def => (
                <Card 
                    key={def.id}
                    className={cn(!def.is_active && 'bg-muted/50 opacity-70')} // [cite: 1]
                >
                    <CardHeader>
                        <div className="flex flex-col md:flex-row justify-between md:items-start gap-2">
                            <div>
                                <CardTitle className="text-lg text-primary"> {/* [cite: 1] */}
                                    {def.name}
                                </CardTitle>
                                <Badge variant="secondary" className="mt-1 md:ml-2 text-xs font-mono"> {/* [cite: 19] */}
                                    {def.condition_code}
                                </Badge>
                            </div>
                            <Badge variant={def.is_active ? 'default' : 'destructive'} className={cn(
                                "w-fit mt-2 md:mt-0",
                                def.is_active ? 'bg-brand-growth-green hover:bg-brand-growth-green/90 text-white' : '' // Custom green for active from guide [cite: 1, 19]
                            )}>
                                {def.is_active ? 'Active' : 'Inactive'}
                            </Badge>
                        </div>
                    </CardHeader>
                    <CardContent className="space-y-2">
                        <p className="text-sm text-foreground">{def.description || "No description provided."}</p> {/* [cite: 1] */}
                        {def.config_schema_guidance && (
                            <div className="mt-2">
                                <p className="text-xs font-medium text-muted-foreground">Config Guidance:</p> {/* [cite: 1] */}
                                <pre className="text-xs bg-muted p-2 rounded overflow-x-auto mt-1"> {/* [cite: 1] */}
                                    {JSON.stringify(def.config_schema_guidance, null, 2)}
                                </pre>
                            </div>
                        )}
                        {def.applicable_question_types_filter && def.applicable_question_types_filter.length > 0 && (
                             <div className="mt-2">
                                <p className="text-xs font-medium text-muted-foreground">Applicable Question Types:</p> {/* [cite: 1] */}
                                <p className="text-xs text-foreground">{def.applicable_question_types_filter.join(', ')}</p> {/* [cite: 1] */}
                            </div>
                        )}
                    </CardContent>
                    <CardFooter className="flex justify-end pt-4">
                         <Button variant="outline" size="sm" onClick={() => onEdit(def)}>
                            Edit
                        </Button> {/* [cite: 12, 13] */}
                        {/* Optional: Delete button
                        {onDelete && (
                            <Button variant="destructive" size="sm" onClick={() => onDelete(def.id)} className="ml-2"> 
                                Delete 
                            </Button>
                        )}
                        */}
                    </CardFooter>
                </Card>
            ))}
        </div>
    );
}